import { MGPFallible } from '@everyboard/lib';
import { MoveWithTwoCoords } from '../../../jscaip/MoveWithTwoCoords';
import { TaflMove } from '../TaflMove';
export class TablutMove extends TaflMove {
    static encoder = MoveWithTwoCoords.getFallibleEncoder(TablutMove.from);
    static from(start, end) {
        const validity = TaflMove.isValidDirection(start, end);
        if (validity.isFailure()) {
            return validity.toOtherFallible();
        }
        else {
            return MGPFallible.success(new TablutMove(start, end));
        }
    }
    getMaximalDistance() {
        return 9;
    }
}
